export default __webpack_public_path__ + "static/media/0053.e0c77b0d.png";